export default __webpack_public_path__ + "static/media/file-new.fa76c126.svg";